import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

import { coreTimelineDetailsReducers, coreTimelineDetailsWatchers } from './details';
import { coreTimelineExportReducers, coreTimelineExportWatchers } from './export';
import { coreTimelineGroupedSummaryReducers, coreTimelineGroupedSummaryWatchers } from './grouped-summary';
import { coreTimelineSummaryReducers, coreTimelineSummaryWatchers } from './summary';
import { coreTimelineSynopsisReducers, coreTimelineSynopsisWatchers } from './synopsis';
import { coreTimelineUserChangesReducers, coreTimelineUserChangesWatchers } from './user-changes';

export const coreTimelineReducers = combineReducers({
	details: coreTimelineDetailsReducers,
	export: coreTimelineExportReducers,
	groupedSummary: coreTimelineGroupedSummaryReducers,
	summary: coreTimelineSummaryReducers,
	synopsis: coreTimelineSynopsisReducers,
	userChanges: coreTimelineUserChangesReducers
});

export const coreTimelineWatchers = combineAllWatchers([
	coreTimelineDetailsWatchers,
	coreTimelineExportWatchers,
	coreTimelineGroupedSummaryWatchers,
	coreTimelineSummaryWatchers,
	coreTimelineSynopsisWatchers,
	coreTimelineUserChangesWatchers
]);
